import React, { useLayoutEffect } from 'react';
import cn from 'classnames';
import Tag from 'components/UI/Tag';
import { observer, tagsStore as store } from 'store';
import * as styles from './TagCheckboxGroup.module.scss';

const TagCheckboxGroup = ({ className, storeId, tags }) => {
  const activeTags = store.getTags(storeId);

  const handleClick = target => () => {
    let result = [...activeTags];

    if (!activeTags.includes(target)) {
      result.push(target);
    } else {
      result = result.filter(item => item !== target);
    }

    store.updateTags(storeId, result);
  };

  useLayoutEffect(() => {
    store.initTags(storeId);
  }, []);

  return (
    <div className={cn(styles.formSelect, className)} role="group" aria-labelledby="checkbox-group">
      {tags?.map(tag => (
        <label key={tag} className={styles.checkbox}>
          <Tag
            key={tag}
            type="button"
            className={styles.formSelectItem}
            onClick={handleClick(tag)}
            active={activeTags?.includes(tag)}
            theme="formTag"
          >
            {tag}
          </Tag>
        </label>
      ))}
    </div>
  );
};

export default observer(TagCheckboxGroup);
